import { create } from "zustand";

// LQC-2985 - answers from GET /Calendars/{code}/holidays/{date}, keyed by calendar and
// date, so every widget showing the same date shares one request and one answer.

export enum HolidayCheckStatus {
  Loading = "Loading",
  Loaded = "Loaded",
  Error = "Error",
}

export interface IHolidayCheck {
  status: HolidayCheckStatus;
  isHoliday: boolean;
  calendarName: string;
}

type State = {
  holidayChecksByKey: Record<string, IHolidayCheck>;
};

type Actions = {
  setHolidayCheck: (key: string, check: IHolidayCheck) => void;
  clearHolidayChecks: () => void;
};

const holidayCalendarStore = create<State & Actions>((set) => ({
  holidayChecksByKey: {},
  setHolidayCheck: (key, check) =>
    set((state) => ({
      holidayChecksByKey: { ...state.holidayChecksByKey, [key]: check },
    })),
  clearHolidayChecks: () => set({ holidayChecksByKey: {} }),
}));

export default holidayCalendarStore;
